<template>
  <div>
    <div class="bg">
      <!--      <dv-loading v-if="loading">Loading...</dv-loading>-->
      <Nav title="游客行为画像" @getTime="getTime" @address="addressList"/>
      <div style="position:relative;flex: 1;overflow-y: auto">
        <div class="totalList">
          <div>
            <el-button v-for="(i,index) in provinceList" size="mini" :class="{active: i.index === currentProvince}"
                       @click="provinceChoose(i.index)" :key="index">{{ i.title }}
            </el-button>
          </div>
          <div>
            <el-button v-for="(i,index) in dataIndex" size="mini" :class="{active: i.index === currentDataIndex}"
                       @click="dataIndexChoose(i.index)" :key="index">{{ i.title }}
            </el-button>
          </div>
        </div>
        <div :style="{display:currentDataIndex==1? 'grid' : 'none' }" class="box-middle">
          <div class="item-a">
            <div class="left-box-text">性别分析</div>
            <div class="bg-item">
              <div style="height: 100%;display: flex;flex-direction: column;justify-content: space-evenly">
                <div id="Chart_1" style="width: 100%;height: 100%"></div>
              </div>
            </div>
          </div>
          <div class="item-b">
            <div class="bg-item" style="width: 100%;height: 100%">
              <div style="height:49%;display: flex;justify-content: space-between;">
                <div style="width: 30%;height: 100%">
                  <div class="backGround-line">消费自由度</div>
                  <div id="consumeFreedom" style="height: 100%;width: 100%;"></div>
                </div>
                <div style="width: 30%;height: 100%">
                  <div class="backGround-line">综合收入水平</div>
                  <div id="incomeLevel" style="height: 100%;width: 100%;"></div>
                </div>
                <div style="width: 30%;height: 100%">
                  <div class="backGround-line">综合消费水平</div>
                  <div id="consumeLevel" style="height: 100%;width: 100%;"></div>
                </div>
              </div>
              <div style="height:49%;display: flex;justify-content: space-between;">
                <div style="width: 50%;height: 100%">
                  <div class="backGround-line">消费品级</div>
                  <div style="width: 100%;height: 100%" id="consumeGrade"></div>
                </div>
                <div style="width: 50%;height: 100%">
                  <div class="backGround-line">有车比列</div>
                  <div style="width: 100%;height: 100%" id="carRate"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="item-a">
            <div class="bg-item">
              <div style="height:  100%;">
                <div id="eduChart" style="width: 100%;height: 100%;"></div>
              </div>
            </div>
            <div class="left-box-text">学历分析</div>
          </div>
          <div class="item-a">
            <div class="left-box-text">年龄分析</div>
            <div class="bg-item">
              <div style="height: 100%;">
                <div id="ageChart" style="width: 100%;height: 100%;"></div>
              </div>
            </div>
          </div>
          <div class="item-a">
            <div class="bg-item">
              <div style="height: 100%;">
                <div id="careerChart" style="width: 100%;height:100%;"></div>
              </div>
            </div>
            <div class="left-box-text">职业类型</div>

          </div>
          <div class="item-a">
            <div class="left-box-text">是否大学生</div>
            <div class="bg-item">
              <div
                  style="height: 100%;padding: 20px;display: flex;flex-direction: column;justify-content: space-between">
                <div>
                  <span>是否是大学生</span>
                  <div class="progress-container">
                    <div class="progress-bar"
                         :style="{ width: ChildRate.collegeStudentRate + '%', backgroundColor: 'red' }">
                    </div>
                  </div>
                  <span>{{ ChildRate.collegeStudentRate }}%</span>
                </div>
                <div>
                  <span>目前婚姻状态</span>
                  <div class="progress-container">
                    <div class="progress-bar"
                         :style="{ width: ChildRate.marriage + '%', backgroundColor: 'red' }">
                    </div>
                  </div>
                  <span>{{ ChildRate.marriage }}%</span>
                </div>
                <div>
                  <span>有无子女状态</span>
                  <div class="progress-container">
                    <div class="progress-bar"
                         :style="{ width: ChildRate.isHaveChild + '%', backgroundColor: 'red' }">
                    </div>
                  </div>
                  <span>{{ ChildRate.isHaveChild }}%</span>
                </div>
              </div>
            </div>
          </div>
          <div class="item-a">
            <div class="left-box-text">子女阶段</div>
            <div class="bg-item">
              <div style="height:  100%;">
                <div id="childRateChart" style="width: 100%;height: 100%;"></div>
              </div>
            </div>
          </div>
          <div class="item-a">
            <div class="bg-item">
              <div style="height: 100%;">
                <div id="ServiceChart" style="width: 100%;height: 100%;"></div>
              </div>
            </div>
            <div class="left-box-text">运营商</div>
          </div>
          <div class="item-a">
            <div class="bg-item">
              <div id="BrandChart" style="height: 100%;"></div>
            </div>
            <div class="left-box-text">手机品牌</div>
          </div>
        </div>
        <div :style="{display:currentDataIndex==2? 'flex' : 'none' }"
             style="display: flex;justify-content: space-between;width: 100%;height: 90%">
          <div style="width:60%;display: flex;justify-content: space-between;height: 100%">
            <div style="width: 40%;height: 100%">
              <el-table
                  :data="data"
                  height="100%"
              >
                <el-table-column
                    prop="index"
                    label="排名"
                >
                </el-table-column>
                <el-table-column
                    prop="city"
                    label="区域"
                >
                </el-table-column>
                <el-table-column
                    prop="count"
                    label="热度指数">
                </el-table-column>
              </el-table>
            </div>
            <div style="width: 60%;height: 100%;display: flex;flex-direction: column;justify-content: space-between">
              <div style="width: 100%;height: 70%;">
                <div id="mapAll" style="width: 100%;height: 100%;"></div>
              </div>
              <div class="back" style="height: 30%;background-color: rgba(19, 25, 47, 0.6);width: 100%">
                <div class="backGround-line">出行方式偏好</div>
                <div id="travel" style="width: 100%;height: 90%; "></div>
              </div>
            </div>
          </div>
          <div style="width:39%;height: 100%;display: flex;flex-direction: column;justify-content: space-between">
            <div style="height: 29%;background-color: rgba(19, 25, 47, 0.6);">
              <div style="width: 100%;height: 100%">
                <div class="backGround-line">旅游满意度</div>
                <div id="TravelSatisfaction" style="width: 100%;height: 100%"></div>
              </div>
            </div>
            <div
                style="height: 35%;background-color: rgba(19, 25, 47, 0.6);display: flex;justify-content: space-between">
              <div style="width: 50%;height: 100%">
                <div class="backGround-line">餐饮类型偏好</div>
                <div id="getCatering" style="width: 100%;height: 100%"></div>
              </div>
              <div style="width: 50%;height: 100%">
                <el-table
                    :data="getCatering"
                    height="100%"
                >
                  <el-table-column
                      prop="catering"
                      label="类型"
                  >
                  </el-table-column>
                  <el-table-column
                      prop="count"
                      label="数量"
                  >
                  </el-table-column>

                </el-table>
              </div>
            </div>
            <div
                style="height: 30%;background-color: rgba(19, 25, 47, 0.6);display: flex;justify-content: space-between">
              <div style="width: 50%;height: 100%">
                <div class="backGround-line">酒店品牌偏好</div>
                <el-table
                    :data="getHotel.hotelBrand"
                    height="90%"
                >
                  <el-table-column
                      prop="hotel_brand"
                      label="酒店名称"
                  >
                  </el-table-column>
                  <el-table-column
                      prop="count"
                      label="数量"
                  >
                  </el-table-column>
                  <el-table-column
                      prop="percentage"
                      label="占比"
                  >
                  </el-table-column>
                </el-table>
              </div>
              <div style="width: 50%;height: 100%">
                <div class="backGround-line">酒店类型偏好</div>
                <div id="getHotel" style="width: 100%;height: 100%"></div>
              </div>
            </div>
          </div>
        </div>
        <div :style="{display:currentDataIndex==3? 'flex' : 'none' }"
             style="display: flex;justify-content: space-between;width: 100%;height: 90%;">
          <div style="width: 59%;height: 100%;display: flex;flex-direction: column;justify-content: space-between;">
            <div
                style="height: 15%;background-color: rgba(19, 25, 47, 0.6);display: flex;flex-direction: column;justify-content: space-between">
              <div class="getApp">
                <el-button v-for="(i,index) in Object.keys(getAppTypeList)" size="mini"
                           @click="TypeList(i,index)"
                           :class="{active: currentAppType.includes(i)}"
                           :disabled="!currentAppType.includes(i) && currentAppType.length>=3"
                           :key="index">{{ getAppTypeList[i] }}
                </el-button>
              </div>
              <div style="text-align: right">
                <div>已选中{{ currentAppType.length }}/ 3</div>
                <el-button style="background-color: #409EFF; " @click="getAppListSumbit">确认选择</el-button>
              </div>
            </div>

            <div
                style="display: grid;grid-template-columns: repeat(3,1fr);gap: 10px;background-color: rgba(19, 25, 47, 0.6);height: 84%;overflow-y: auto"
                class="hide-scroll">
              <div v-for="(i,index) in getAppList" :key="index">
                <div class="backGround-line">{{ i.name }}</div>
                <div>
                  <div v-for="(item,index1) in i.list" :key="index1" style="padding: 5px 10px;margin:0 auto">
                    <div style="display: flex;justify-content: space-between;align-items: center">
                      <span>{{ item.app_name }}</span>
                      <span>{{ item.percentage }}%</span>
                    </div>
                    <el-progress :percentage="item.percentage"></el-progress>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="width: 40%;height: 100%; display: flex;flex-direction: column;justify-content: space-between">
            <div
                style="height: 40%;background-color: rgba(19, 25, 47, 0.6);display: flex;justify-content: space-between;align-items: center">
              <div style="width: 50%;height: 100%">
                <div class="backGround-line">应用时长</div>
                <div id="appUseTime" style="width: 100%;height: 100%"></div>
              </div>
              <div style="width: 50%;height: 100%">
                <div class="backGround-line">应用使用频率</div>
                <div id="appUseFrequence" style="width: 100%;height: 100%"></div>
              </div>
            </div>
            <div style="height: 59%;background-color: rgba(19, 25, 47, 0.6)">
              <div class="backGround-line">APP安装</div>
              <div id="AppInstallTop" style="width: 100%;height: 100%"></div>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
import Nav from "_c/Nav/Nav.vue"
import * as echarts from 'echarts';
import 'echarts-wordcloud'
import China from '@/assets/china.json'
import generateRandomColors from '@/utils/randomColor/randomColor'
import {
  touristsBehaviorGetGenderAndAgeRate,
  touristsBehaviorGetEducationAndJobRate,
  touristsBehaviorGetConsumeFreedom,
  touristsBehaviorGetConsumeGradeAndCarRate,
  touristsBehaviorGetMarriageAndChildRate,
  touristsBehaviorGetServiceAndBrandRate,
  travelPerformanceGetActiveCityTop20,
  travelPerformanceGetTransportationRate,
  travelPerformanceGetTravelSatisfaction,
  travelPerformanceGetCateringTop10,
  travelPerformanceGetHotelTop10,
  appPerformanceGetAppTypeList,
  appPerformanceGetAppList,
  appPerformanceGetAppUseFrequenceAndTime,
  appPerformanceGetAppInstallTop
} from '@/request/UserPortrait/UserPortrait'
import 'echarts-liquidfill'// 引入水球图扩展
export default {
  components: {
    Nav
  },
  data() {
    return {
      form: {}, // 参数对象
      provinceList: [{title: '总体', index: ''}, {title: '本区县', index: '1'}, {
        title: '外区县',
        index: '2'
      }, {title: '本市', index: '3'}, {title: '外市', index: '4'}, {title: '本省', index: '5'}, {
        title: '外省',
        index: '6'
      }],
      data: [],
      col: [{label: '排名', prop: 'index'}, {label: '区域', prop: 'city',}, {label: '热度指数', prop: 'count'},],
      currentProvince: '',  // 标记被选中的状态
      dataIndex: [{title: '游客基本特征', index: '1'}, {title: '旅游出行偏好', index: '2'}, {
        title: 'APP使用偏好',
        index: '3'
      }],
      currentDataIndex: '1', //标记被选中的状态
      currentAppType: [], // 选过的app 类型存储起来
      Chart_1: null,  // 年龄实列
      Chart_2: null, // 年龄实列
      chart_3: null, // 学历实列
      chart_4: null, // 职业实列
      chart_5: null, //消费自由度实列
      chart_6: null, //综合收入水平实列
      chart_7: null, //综合消费水平实列
      chart_8: null, // 消费品级 实列
      chart_9: null, // 有车比列 实列
      chart_10: null, // 子女阶段实列
      chart_11: null, // 运营商实列
      chart_12: null, // 手机品牌实列
      chart_2_1: null,  // 地图实列
      chart_2_2: null, // 出行方式
      chart_2_3: null, // 旅游满意度
      chart_2_4: null, // 餐饮类型偏好
      chart_2_5: null, // 酒店类型偏好酒店品牌
      chart_2_6: null, // 应用时长
      chart_2_7: null, // 应用频率
      chart_2_8: null, // app安装雷达
      loading: true,
      ChildRate: [],  // 大学生婚姻子女数据
      getCatering: [],// 餐饮类型数据
      getHotel: [], // 酒店类型酒店品牌
      getAppTypeList: [],// 获取app类型列表数据
      getAppList: [], // 旅游偏好存储数据
      title: "游客行为画像",
      valueTime: "",
      valueCity: '',
      waterMan: {
        data: [24, 45],
        shape: 'roundRect',
        formatter: '{value}%',
        waveNum: 1
      },
      waterWoMan: {
        data: [55, 55],
        shape: 'roundRect',
        formatter: '{value}%',
        waveNum: 1
      },
    }
  },
  methods: {
    // 年龄性别 默认加载
    myChartSex() {
      this.Chart_1 = echarts.init(document.getElementById('Chart_1'))
      this.Chart_2 = echarts.init(document.getElementById('ageChart'))
      touristsBehaviorGetGenderAndAgeRate().then(res => {
        let data = res.data.data.gender.map(item => ({
          value: item.count,
          name: item.gender
        }))
        let color = ["#FF5733", "#3357FF",];
        let dataAge = res.data.data.age.map(item => item.age_group)
        let dataAgeNum = res.data.data.age.map(item => item.count)
        this.Chart_1.setOption({
          //你的代码
          backgroundColor: "transparent",
          color: color,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
            },
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['30%', '60%'],
              center: ['50%', '55%'], // 修改为居中
              avoidLabelOverlap: true,
              label: {
                color: '#fff',
                alignTo: 'labelLine',
                formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                minMargin: 5,
                edgeDistance: 10,
                lineHeight: 15,
                rich: {
                  num: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  },
                  zb: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  }
                }
              },
              labelLine: {
                length: 15,
                length2: 40,
                maxSurfaceAngle: 80
              },
              data: data
            }
          ]
        })
        this.Chart_2.setOption({
          backgroundColor: 'transparent',
          tooltip: {
            trigger: 'item', // 触发类型，'item' 数据项图形触发，'axis' 坐标轴触发
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 `;
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [{
            type: 'category',
            data: dataAge,
            axisLine: {
              show: true,
              lineStyle: {
                color: "#063374",
                width: 1,
                type: "solid"
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#00c7ff",
                fontSize: "8"
              }
            },
          }],
          yAxis: [{
            type: 'value',
            axisLabel: {
              formatter: '{value}'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#00c7ff",
                width: 1,
                type: "solid"
              },
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: "#063374",
              }
            }
          }],
          series: [{
            type: 'bar',
            data: dataAgeNum,
            barWidth: 20,
            barGap: 1, //柱子之间间距
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#00fcae'
                }, {
                  offset: 1,
                  color: '#006388'
                }]),
                opacity: 1,
              }
            }
          }]
        })
      })
    },
    // 学历水平 职业 默认加载
    myChartEdu() {
      this.chart_3 = echarts.init(document.getElementById("eduChart"))
      this.chart_4 = echarts.init(document.getElementById("careerChart"))
      touristsBehaviorGetEducationAndJobRate().then(res => {
        var dataList = res.data.data.education.map(item => item.count);
        let indicator = res.data.data.education.map(item => ({
          name: item.education,
        }))
        this.chart_3.setOption({
          backgroundColor: 'transparent',
          color: ['#DC0606', '#DCDC06'],
          tooltip: {
            show: true // 弹层数据去掉
          },
          legend: {
            show: false,
          },
          radar: {
            center: ['50%', '50%'], // 外圆的位置
            radius: '55%',
            name: {
              textStyle: {
                color: '#fff',
                fontSize: 16,
                fontWeight: 400,
                fontFamily: 'PingFangSC-Regular,PingFang SC',
                fontStyle: 'normal',
              }
            },
            // TODO:
            indicator: indicator,
            splitArea: {
              // 坐标轴在 grid 区域中的分隔区域，默认不显示。
              show: true,
              areaStyle: {
                // 分隔区域的样式设置。
                color: ['#1c2330'] // 分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色。
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                type: "dashed",
                color: '#603737'
              }
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: '#603737', // 分隔线颜色
                width: 1 // 分隔线线宽
              }
            }
          },
          series: [
            {
              type: 'radar',
              symbolSize: 6,
              data: [
                {
                  // TODO:
                  value: dataList,
                  itemStyle: {
                    borderColor: 'rgba(220, 220, 6, 1)',
                    color: '#fbf9b4',
                    borderWidth: 2
                  },
                  lineStyle: {
                    normal: {
                      width: 1,
                      color: 'rgba(220, 220, 6, 1)',
                    }
                  },
                  areaStyle: {
                    normal: {
                      color: {
                        type: 'radial',
                        x: 0.5,
                        y: 0.5,
                        r: 0.5,
                        colorStops: [{
                          offset: 0, color: 'rgba(255, 127,0, 0.14)' // 0% 处的颜色
                        },
                          {
                            offset: 0.15, color: 'rgba(255, 127,0, 0.14)' // 100% 处的颜色
                          },
                          {
                            offset: 0.75, color: 'rgba(2255, 127,0, 0.4)' // 100% 处的颜色
                          },
                          {
                            offset: 1, color: 'rgba(255, 127,0, 0.5)' // 100% 处的颜色
                          }],
                        global: false // 缺省为 false
                      }
                    }
                  },
                }
              ]
            }
          ]
        })
        let add = res.data.data.job.map(item => ({
          value: item.count,
          name: item.job
        }))
        let data = add.slice(0, 10)
        var colors = [
          "#FF5733",
          "#33FF57",
          "#3357FF",
          "#FF33A1",
          "#9033FF",
          "#33FFF6",
          "#FFBD33",
          "#FF3333",
          "#FFFFFF"
        ];
        this.chart_4.setOption({
          //你的代码
          backgroundColor: "transparent",
          color: colors,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
            },
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['30%', '60%'],
              center: ['50%', '55%'], // 修改为居中
              avoidLabelOverlap: true,
              label: {
                color: '#fff',
                alignTo: 'labelLine',
                formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                minMargin: 5,
                edgeDistance: 10,
                lineHeight: 15,
                rich: {
                  num: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  },
                  zb: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  }
                }
              },
              labelLine: {
                length: 15,
                length2: 40,
                maxSurfaceAngle: 80
              },
              data: data
            }
          ]
        })
      })

    },
    // 消费自由度 综合收入水平 综合消费水平
    myChartFreeDom() {
      this.chart_5 = echarts.init(document.getElementById('consumeFreedom'));
      this.chart_6 = echarts.init(document.getElementById('incomeLevel'));
      this.chart_7 = echarts.init(document.getElementById('consumeLevel'));
      touristsBehaviorGetConsumeFreedom().then(res => {
        var data = res.data.data.consumeFreedom.map(item => ({
          value: item.count,
          name: item.consumeFreedom
        }))
        let colors = ["#FF5733", "#3357FF", '#fff'];
        this.chart_5.setOption({
          //你的代码
          backgroundColor: "transparent",
          color: colors,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
            },
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['20%', '40%'],
              center: ['50%', '55%'], // 修改为居中
              avoidLabelOverlap: true,
              label: {
                color: '#fff',
                alignTo: 'labelLine',
                formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                minMargin: 5,
                edgeDistance: 10,
                lineHeight: 15,
                rich: {
                  num: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  },
                  zb: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  }
                }
              },
              labelLine: {
                length: 5,
                length2: 10,
                maxSurfaceAngle: 80
              },
              data: data
            }
          ]
        })
        var data1 = res.data.data.incomeLevel.map(item => ({
          value: item.count,
          name: item.incomeLevel
        }))
        this.chart_6.setOption({
          //你的代码
          backgroundColor: "transparent",
          color: colors,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
            },
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['20%', '40%'],
              center: ['50%', '55%'], // 修改为居中
              avoidLabelOverlap: true,
              label: {
                color: '#fff',
                alignTo: 'labelLine',
                formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                minMargin: 5,
                edgeDistance: 10,
                lineHeight: 15,
                rich: {
                  num: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  },
                  zb: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  }
                }
              },
              labelLine: {
                length: 5,
                length2: 10,
                maxSurfaceAngle: 80
              },
              data: data1
            }
          ]
        })
        var data2 = res.data.data.consumeLevel.map(item => ({
          value: item.count,
          name: item.consumeLevel
        }))
        this.chart_7.setOption({
          //你的代码
          backgroundColor: "transparent",
          color: colors,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
            },
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['20%', '40%'],
              center: ['50%', '55%'], // 修改为居中
              avoidLabelOverlap: true,
              label: {
                color: '#fff',
                alignTo: 'labelLine',
                formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                minMargin: 5,
                edgeDistance: 10,
                lineHeight: 15,
                rich: {
                  num: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  },
                  zb: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  }
                }
              },
              labelLine: {
                length: 5,
                length2: 10,
                maxSurfaceAngle: 80
              },
              data: data2
            }
          ]
        })
      })
    },
    // 消费品级有车比例
    myChartCar() {
      this.chart_8 = echarts.init(document.getElementById('consumeGrade'));
      this.chart_9 = echarts.init(document.getElementById('carRate'));
      touristsBehaviorGetConsumeGradeAndCarRate().then(res => {
        let data = res.data.data.consumeGrade.map(item => item.consume_grade)
        let dataNum = res.data.data.consumeGrade.map(item => item.count)
        this.chart_8.setOption({
          backgroundColor: 'transparent',
          tooltip: {
            trigger: 'item', // 触发类型，'item' 数据项图形触发，'axis' 坐标轴触发
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 `;
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [{
            type: 'category',
            data: data,
            axisLine: {
              show: true,
              lineStyle: {
                color: "#063374",
                width: 1,
                type: "solid"
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#00c7ff",
                fontSize: "8"
              }
            },
          }],
          yAxis: [{
            type: 'value',
            axisLabel: {
              formatter: '{value}'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#00c7ff",
                width: 1,
                type: "solid"
              },
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: "#063374",
              }
            }
          }],
          series: [{
            type: 'bar',
            data: dataNum,
            barWidth: 20,
            barGap: 1, //柱子之间间距
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#00fcae'
                }, {
                  offset: 1,
                  color: '#006388'
                }]),
                opacity: 1,
              }
            }
          }]
        })
        let value1 = res.data.data.isHaveCar[0].count
        let value2 = res.data.data.isHaveCar[1].count
        let value = (value1 / value2).toFixed(2)
        console.log(value)
        this.chart_9.setOption({
          backgroundColor: 'transparent',
          title: {
            text: '有车比列',
            textStyle: {
              fontSize: 12,
              color: "rgba(255, 255, 255, 0.7)",
              rich: {
                a: {
                  fontSize: 36,
                },
              },
            },
            x: "center",
            y: "40%",
          },
          graphic: [
            {
              type: "group",
              left: "center",
              top: "50%",
              children: [
                {
                  type: "text",
                  z: 100,
                  left: "10",
                  top: "middle",
                  style: {
                    fill: "#ffffff",
                    text: value * 100 + "%",
                    font: "36px",
                    //   fontFamily: "FZHZGBJW",
                  },
                }
              ],
            },
          ],
          series: [
            {
              name: "水球图",
              type: "liquidFill",
              radius: "50%",

              data: [0.3],
              color: [
                {
                  type: "linear",
                  x: 0,
                  y: 1,
                  x2: 0,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 1,
                      color: ["rgba(2,144,255,0.4)"], // 0% 处的颜色
                    },
                    {
                      offset: 0,
                      color: ["rgba(45,175,230,0.8)"], // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              ],
              label: {
                formatter: "",
              },
              outline: {
                show: true,
                borderDistance: 0,
                itemStyle: {
                  borderColor: new echarts.graphic.LinearGradient(
                      0,
                      1,
                      0,
                      0,
                      [
                        {
                          offset: 1,
                          color: "rgba(21, 80, 161, 0.01)",
                        },
                        {
                          offset: 0,
                          color: "rgba(15, 115, 238, 0.6)",
                        },
                      ]
                  ),
                  borderWidth: 3,
                },
              },
              backgroundStyle: {
                color: new echarts.graphic.RadialGradient(0.5, 0.5, 0.5, [
                  {
                    offset: 1,
                    color: "rgba(15, 115, 238,0.3)",
                  },
                  {
                    offset: 0.95,
                    color: "rgba(15, 115, 238, 0.5)",
                  },
                  {
                    offset: 0.8,
                    color: "rgba(15, 115, 238, 0.3)",
                  },
                  {
                    offset: 0.4,
                    color: "rgba(21, 80, 161, 0.01)",
                  },
                ]),
              },
            },
          ],
        })
      })
    },
    // 是否大学生婚姻子女阶段
    myChartMarriage() {
      this.chart_10 = echarts.init(document.getElementById('childRateChart'));
      touristsBehaviorGetMarriageAndChildRate().then(res => {
        this.ChildRate = res.data.data;
        let data = this.ChildRate.marriage[0].count / (this.ChildRate.marriage[0].count + this.ChildRate.marriage[1].count)
        let isHaveChild = this.ChildRate.isHaveChild[0].count / (this.ChildRate.isHaveChild[0].count + this.ChildRate.isHaveChild[1].count)
        this.ChildRate.marriage = data.toFixed(2) * 100
        this.ChildRate.isHaveChild = isHaveChild.toFixed(2) * 100
        const basicColors = [
          ['#159AFF', 'rgba(0, 58, 255, 0.0001)'],
          ['#26BFBF', 'rgba(36, 190, 190, 0.0001)'],
          ['#A0C2E4', 'rgba(83, 105, 128, 0.0001)'],
          ['#FFB515', 'rgba(255, 140, 0, 0.0001)'],
          ['#43CBFF', '#9870CC'],
          ['#FCCF31', '#F55555'],
          ['#F761A1', '#8C1BAB'],
          ['#81FBB8', '#28C76F']
        ]

        function genLinearGradient(colors) {
          const color = {
            type: 'linear',
            x: 1,
            y: 0,
            x2: 0,
            y2: 0,
            colorStops: [
              {
                offset: 0,
                color: colors[0] // 0%处的颜色
              },
              {
                offset: 1,
                color: colors[1] // 100%处的颜色
              }
            ],
            global: false
          }
          return color
        }

        const dataName = res.data.data.childStage.map(item => item.child_stage)
        const dataList = res.data.data.childStage.map(item => item.count)
        this.chart_10.setOption({
          backgroundColor: "transparent",
          grid: {
            left: '12%',
            top: '5%',
            bottom: '12%',
            right: '8%'
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              lineStyle: {
                color: 'rgba(255,255,255,0.8)'
              }
            }
          },
          xAxis: {
            data: dataName,
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(255, 129, 109, 0.1)',
                width: 1 // 这里是为了突出显示加上的
              }
            },
            axisLabel: {
              textStyle: {
                color: '#fff',
                fontSize: 12
              }
            }
          },
          yAxis: [{
            splitNumber: 2,
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(255, 129, 109, 0.1)',
                width: 1 // 这里是为了突出显示加上的
              }
            },
            axisLabel: {
              textStyle: {
                color: '#fff'
              }
            },
            splitArea: {
              areaStyle: {
                color: 'rgba(255,255,255,.5)'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255, 129, 109, 0.1)',
                width: 0.5,
                type: 'dashed'
              }
            }
          }
          ],
          series: [{
            name: 'hill',
            type: 'pictorialBar',
            barCategoryGap: '0%',
            symbol: 'path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z',
            label: {
              show: false,
              position: 'top',
              distance: 15,
              color: '#FFF6B7',
              fontWeight: 'bolder',
              fontSize: 20,
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  return genLinearGradient(basicColors[params.dataIndex])
                }
              },
              emphasis: {
                opacity: 1
              }
            },
            data: dataList,
            z: 10
          }]
        })

      })

    },
    // 手机运营商
    myChartPhone() {
      this.chart_11 = echarts.init(document.getElementById('ServiceChart'));
      this.chart_12 = echarts.init(document.getElementById('BrandChart'));
      touristsBehaviorGetServiceAndBrandRate().then(res => {
        let data = res.data.data.service.map(item => ({
          value: item.count,
          name: item.service
        }))
        let color = ["#FF5733", "#3357FF", '#a4fd05'];
        this.chart_11.setOption({
          //你的代码
          backgroundColor: "transparent",
          color: color,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
            },
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['30%', '60%'],
              center: ['50%', '55%'], // 修改为居中
              avoidLabelOverlap: true,
              label: {
                color: '#fff',
                alignTo: 'labelLine',
                formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                minMargin: 5,
                edgeDistance: 10,
                lineHeight: 15,
                rich: {
                  num: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  },
                  zb: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  }
                }
              },
              labelLine: {
                length: 15,
                length2: 40,
                maxSurfaceAngle: 80
              },
              data: data
            }
          ]
        })
        let dataAge = res.data.data.brand.map(item => item.phone_brand)
        let dataAgeNum = res.data.data.brand.map(item => item.count)
        this.chart_12.setOption({
          backgroundColor: 'transparent',
          tooltip: {
            trigger: 'item', // 触发类型，'item' 数据项图形触发，'axis' 坐标轴触发
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 `;
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [{
            type: 'category',
            data: dataAge,
            axisLine: {
              show: true,
              lineStyle: {
                color: "#063374",
                width: 1,
                type: "solid"
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#00c7ff",
                fontSize: "8"
              }
            },
          }],
          yAxis: [{
            type: 'value',
            axisLabel: {
              formatter: '{value}'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#00c7ff",
                width: 1,
                type: "solid"
              },
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: "#063374",
              }
            }
          }],
          series: [{
            type: 'bar',
            data: dataAgeNum,
            barWidth: 20,
            barGap: 1, //柱子之间间距
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#00fcae'
                }, {
                  offset: 1,
                  color: '#006388'
                }]),
                opacity: 1,
              }
            }
          }]
        })
      })

    },
    //  游客活跃城市
    getActiveCityTop() {
      this.chart_2_1 = echarts.init(document.getElementById('mapAll'));
      travelPerformanceGetActiveCityTop20(this.form).then(res => {
        this.data = res.data.data
        this.data.forEach((item, index) => {
          item.index = index + 1;
        });
        var geoCoordMap = {},
            data = [];
        China.features.forEach(function (item) {
          var name = item.properties.name,
              cp = item.properties.center;
          if (cp) {
            geoCoordMap[name] = cp; // 地区经纬度
            data.push({
              name: name,
              value: cp.concat(Math.round(Math.random() * 100))
            })
          }
        });
        let data1 = []
        echarts.registerMap('china', China);
        this.chart_2_1.setOption({
          tooltip: {
            trigger: "item",
            formatter: function (params) {
              if (params.seriesType == "scatter") {
                return "线路：" + params.data.name + "" + params.data.value[2];
              } else if (params.seriesType == "lines") {
                return (
                    params.data.fromName +
                    ">" +
                    params.data.toName +
                    "<br />" +
                    params.data.value
                );
              }
            }
          },
          visualMap: {
            show: false,
            min: 0,
            max: 100,
            left: 'left',
            top: 'bottom',
            text: ['高', '低'], // 文本，默认为数值文本
            calculable: true,
            seriesIndex: [1],
            inRange: {
              color: ['#004693'] // 蓝绿
            }
          },
          geo: {
            show: true,
            map: 'china',
            roam: true,
            zoom: 1.25,
            label: {
              show: true,
              padding: 4,
              color: '#ddd',
              fontFamily: 'pf-zh'
            },
            itemStyle: {
              normal: {
                areaColor: '#031525',
                borderWidth: 1,
                borderColor: '#00CFFC',
              },
              emphasis: {
                areaColor: '#2B91B7',
              }
            }
          },
          series: [
            {
              type: 'map',
              map: 'china',
              geoIndex: 0,
              roam: true,
              aspectScale: 0.75, //长宽比
              showLegendSymbol: false, // 存在legend时显示
              label: {
                normal: {
                  show: true
                },
                emphasis: {
                  show: false,
                  textStyle: {
                    color: '#fff'
                  }
                }
              },
              itemStyle: {
                normal: {
                  areaColor: '#031525',
                  borderColor: '#3B5077'
                },
                emphasis: {
                  areaColor: '#2B91B7'
                }
              },
              animation: false,
              data: data1
            },
            // 散点
            {
              name: '散点',
              type: 'scatter',
              coordinateSystem: 'geo',
              symbolSize: 5,
              label: {
                normal: {
                  show: false,
                  position: 'right'
                }
              },
              itemStyle: {
                normal: {
                  color: 'white'
                }
              },
              zlevel: 10,
              data: data1
            },
            {
              name: '点',
              type: 'scatter',
              coordinateSystem: 'geo',
              symbol: 'pin', //气泡
              symbolSize: function () {
                return 40
              },
              label: {
                show: true,
                formatter: function (parm) {
                  return parm.value[4]
                },
                textStyle: {
                  color: '#0f1325'
                }
              },
              itemStyle: {
                color: '#fff' //标志颜色
              },
              zlevel: 6,
              data: data1
            },
          ]
        })
      })
    },
    //  出行方式偏好
    myChartTravel() {
      this.chart_2_2 = echarts.init(document.getElementById("travel"));
      travelPerformanceGetTransportationRate(this.form).then(res => {
        let dataAge = res.data.data.map(item => item.transportation)
        let dataAgeNum = res.data.data.map(item => item.count)
        this.chart_2_2.setOption({
          backgroundColor: 'transparent',
          tooltip: {
            trigger: 'item', // 触发类型，'item' 数据项图形触发，'axis' 坐标轴触发
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 `;
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [{
            type: 'category',
            data: dataAge,
            axisLine: {
              show: true,
              lineStyle: {
                color: "#063374",
                width: 1,
                type: "solid"
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#00c7ff",
                fontSize: "8"
              }
            },
          }],
          yAxis: [{
            type: 'value',
            axisLabel: {
              formatter: '{value}'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#00c7ff",
                width: 1,
                type: "solid"
              },
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: "#063374",
              }
            }
          }],
          series: [{
            type: 'bar',
            data: dataAgeNum,
            barWidth: 20,
            barGap: 1, //柱子之间间距
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#00fcae'
                }, {
                  offset: 1,
                  color: '#006388'
                }]),
                opacity: 1,
              }
            }
          }]
        })
      })
    },
    // 旅游满意度
    TravelSatisfaction() {
      this.chart_2_3 = echarts.init(document.getElementById("TravelSatisfaction"));
      travelPerformanceGetTravelSatisfaction(this.form).then(res => {
        let data = res.data.data.satisfaction.map(item => ({
          value: item.count,
          name: item.satisfaction
        }))
        let color = ["#FF5733", "#3357FF",];
        this.chart_2_3.setOption({
          //你的代码
          backgroundColor: "transparent",
          color: color,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
            },
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['30%', '60%'],
              center: ['50%', '55%'], // 修改为居中
              avoidLabelOverlap: true,
              label: {
                color: '#fff',
                alignTo: 'labelLine',
                formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                minMargin: 5,
                edgeDistance: 10,
                lineHeight: 15,
                rich: {
                  num: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  },
                  zb: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  }
                }
              },
              labelLine: {
                length: 15,
                length2: 40,
                maxSurfaceAngle: 80
              },
              data: data
            }
          ]
        })
      })
    },
    // 餐饮类型偏好
    getCateringFaction() {
      this.chart_2_4 = echarts.init(document.getElementById("getCatering"));
      travelPerformanceGetCateringTop10(this.form).then(res => {
        this.getCatering = res.data.data
        let data = res.data.data.map(item => ({
          value: item.count,
          name: item.catering
        }))
        let color = generateRandomColors(data.length)
        this.chart_2_4.setOption({
          //你的代码
          backgroundColor: "transparent",
          color: color,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
            },
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['30%', '60%'],
              center: ['50%', '55%'], // 修改为居中
              avoidLabelOverlap: true,
              label: {
                color: '#fff',
                alignTo: 'labelLine',
                formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                minMargin: 5,
                edgeDistance: 10,
                lineHeight: 15,
                rich: {
                  num: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  },
                  zb: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  }
                }
              },
              labelLine: {
                length: 15,
                length2: 40,
                maxSurfaceAngle: 80
              },
              data: data
            }
          ]
        })
      })
    },
    // 酒店品牌
    getHotelFaction() {
      this.chart_2_5 = echarts.init(document.getElementById("getHotel"));
      travelPerformanceGetHotelTop10(this.form).then(res => {
        let data = res.data.data.hotelType.map(item => ({
          value: item.count,
          name: item.hotel_type
        }))
        this.getHotel = res.data.data
        let color = generateRandomColors(data.length)
        this.chart_2_5.setOption({
          //你的代码
          backgroundColor: "transparent",
          color: color,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
            },
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['30%', '60%'],
              center: ['50%', '55%'], // 修改为居中
              avoidLabelOverlap: true,
              label: {
                color: '#fff',
                alignTo: 'labelLine',
                formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                minMargin: 5,
                edgeDistance: 10,
                lineHeight: 15,
                rich: {
                  num: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  },
                  zb: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  }
                }
              },
              labelLine: {
                length: 15,
                length2: 40,
                maxSurfaceAngle: 80
              },
              data: data
            }
          ]
        })
      })
    },
    // 应用时长频率
    getAppUseFrequence() {
      this.chart_2_6 = echarts.init(document.getElementById("appUseTime"));
      this.chart_2_7 = echarts.init(document.getElementById("appUseFrequence"));
      appPerformanceGetAppUseFrequenceAndTime(this.form).then(res => {
        let data = res.data.data.appUseTime.map(item => ({
          value: item.count,
          name: item.app_use_time
        }))
        let color = ["#FF5733", "#3357FF",];
        let data1 = res.data.data.appUseFrequence.map(item => ({
          value: item.count,
          name: item.app_use_frequence
        }))
        let color1 = ["#FF5733", "#3357FF",];
        this.chart_2_6.setOption({
          //你的代码
          backgroundColor: "transparent",
          color: color,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
            },
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['20%', '40%'],
              center: ['50%', '55%'], // 修改为居中
              avoidLabelOverlap: true,
              label: {
                color: '#fff',
                alignTo: 'labelLine',
                formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                minMargin: 5,
                edgeDistance: 10,
                lineHeight: 15,
                rich: {
                  num: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  },
                  zb: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  }
                }
              },
              labelLine: {
                length: 15,
                length2: 40,
                maxSurfaceAngle: 80
              },
              data: data
            }
          ]
        })
        this.chart_2_7.setOption({
          //你的代码
          backgroundColor: "transparent",
          color: color1,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
            },
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['20%', '40%'],
              center: ['50%', '55%'], // 修改为居中
              avoidLabelOverlap: true,
              label: {
                color: '#fff',
                alignTo: 'labelLine',
                formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                minMargin: 5,
                edgeDistance: 10,
                lineHeight: 15,
                rich: {
                  num: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  },
                  zb: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  }
                }
              },
              labelLine: {
                length: 15,
                length2: 40,
                maxSurfaceAngle: 80
              },
              data: data1
            }
          ]
        })
      })
    },
    // app按照top
    getAppInstallTop() {
      this.chart_2_8 = echarts.init(document.getElementById("AppInstallTop"));
      appPerformanceGetAppInstallTop(this.form).then(res => {
        let radarData = res.data.data.app_stats.map(item => ({
          name: item.app_name,
          value: item.user_count
        }))
        let valueList = radarData.map((it) => {
          return it.value;
        });
        let vlueMax = Math.max(...valueList);
        vlueMax = vlueMax + vlueMax * 0.2;
        let indicator = radarData.map((it) => {
          return {name: it.name, max: vlueMax};
        });
        let seriesData = [{value: valueList}];
        this.chart_2_8.setOption({
          backgroundColor: 'transparent',
          title: {
            text: "",
            x: "center",
            textStyle: {
              fontSize: 12
            }
          },
          grid: {
            top: '10%'
          },
          tooltip: {
            show: true,
            trigger: "item"
          },
          radar: {
            center: ["50%", "50%"],
            radius: "70%",
            shape: "circle",
            splitArea: {
              areaStyle: {
                color: ["transparent"]
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "rgba(34,50,129,1)"
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(34,50,129,1)"
              }
            },
            name: {
              textStyle: {
                color: 'white',
                fontSize: 14
              },
            },
            indicator: indicator
          },
          series: [{
            type: "radar",
            name: '月度风险指数',
            symbol: "circle",
            symbolSize: 4,
            itemStyle: {
              normal: {
                color: 'rgba(059, 114, 230,1)',
                borderColor: "rgba(059, 114, 230,0.5)",
                borderWidth: 6
              }
            },
            areaStyle: {
              normal: {
                color: "rgba(059, 114, 230,0.5)"
              }
            },
            lineStyle: {
              normal: {
                color: "rgba(059, 114, 230,1)",
                width: 2,
              }
            },
            label: {

              normal: {
                show: true,
                color: 'white',
                position: 'top'
              }
            },
            data: seriesData
          }]
        })
      })
    },
    // 左上角切换区域触发
    async provinceChoose(value) {
      this.currentProvince = value
      this.form.zoneType = value
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      //年龄性别
      await touristsBehaviorGetGenderAndAgeRate(this.form).then(res => {
        let data = res.data.data.gender.map(item => ({
          value: item.count,
          name: item.gender
        }))
        let color = ["#FF5733", "#3357FF",];
        let dataAge = res.data.data.age.map(item => item.age_group)
        let dataAgeNum = res.data.data.age.map(item => item.count)
        this.Chart_1.setOption({
          //你的代码
          backgroundColor: "transparent",
          color: color,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
            },
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['30%', '60%'],
              center: ['50%', '55%'], // 修改为居中
              avoidLabelOverlap: true,
              label: {
                color: '#fff',
                alignTo: 'labelLine',
                formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                minMargin: 5,
                edgeDistance: 10,
                lineHeight: 15,
                rich: {
                  num: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  },
                  zb: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  }
                }
              },
              labelLine: {
                length: 15,
                length2: 40,
                maxSurfaceAngle: 80
              },
              data: data
            }
          ]
        })
        this.Chart_2.setOption({
          backgroundColor: 'transparent',
          tooltip: {
            trigger: 'item', // 触发类型，'item' 数据项图形触发，'axis' 坐标轴触发
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 `;
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [{
            type: 'category',
            data: dataAge,
            axisLine: {
              show: true,
              lineStyle: {
                color: "#063374",
                width: 1,
                type: "solid"
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#00c7ff",
                fontSize: "8"
              }
            },
          }],
          yAxis: [{
            type: 'value',
            axisLabel: {
              formatter: '{value}'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#00c7ff",
                width: 1,
                type: "solid"
              },
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: "#063374",
              }
            }
          }],
          series: [{
            type: 'bar',
            data: dataAgeNum,
            barWidth: 20,
            barGap: 1, //柱子之间间距
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#00fcae'
                }, {
                  offset: 1,
                  color: '#006388'
                }]),
                opacity: 1,
              }
            }
          }]
        })
      })
      //学历水平 职业
      await touristsBehaviorGetEducationAndJobRate(this.form).then(res => {
        var dataList = res.data.data.education.map(item => item.count);
        let indicator = res.data.data.education.map(item => ({
          name: item.education,
        }))
        this.chart_3.setOption({
          backgroundColor: 'transparent',
          color: ['#DC0606', '#DCDC06'],
          tooltip: {
            show: true // 弹层数据去掉
          },
          legend: {
            show: false,
          },
          radar: {
            center: ['50%', '50%'], // 外圆的位置
            radius: '55%',
            name: {
              textStyle: {
                color: '#fff',
                fontSize: 16,
                fontWeight: 400,
                fontFamily: 'PingFangSC-Regular,PingFang SC',
                fontStyle: 'normal',
              }
            },
            // TODO:
            indicator: indicator,
            splitArea: {
              // 坐标轴在 grid 区域中的分隔区域，默认不显示。
              show: true,
              areaStyle: {
                // 分隔区域的样式设置。
                color: ['#1c2330'] // 分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色。
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                type: "dashed",
                color: '#603737'
              }
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: '#603737', // 分隔线颜色
                width: 1 // 分隔线线宽
              }
            }
          },
          series: [
            {
              type: 'radar',
              symbolSize: 6,
              data: [
                {
                  // TODO:
                  value: dataList,
                  itemStyle: {
                    borderColor: 'rgba(220, 220, 6, 1)',
                    color: '#fbf9b4',
                    borderWidth: 2
                  },
                  lineStyle: {
                    normal: {
                      width: 1,
                      color: 'rgba(220, 220, 6, 1)',
                    }
                  },
                  areaStyle: {
                    normal: {
                      color: {
                        type: 'radial',
                        x: 0.5,
                        y: 0.5,
                        r: 0.5,
                        colorStops: [{
                          offset: 0, color: 'rgba(255, 127,0, 0.14)' // 0% 处的颜色
                        },
                          {
                            offset: 0.15, color: 'rgba(255, 127,0, 0.14)' // 100% 处的颜色
                          },
                          {
                            offset: 0.75, color: 'rgba(2255, 127,0, 0.4)' // 100% 处的颜色
                          },
                          {
                            offset: 1, color: 'rgba(255, 127,0, 0.5)' // 100% 处的颜色
                          }],
                        global: false // 缺省为 false
                      }
                    }
                  },
                }
              ]
            }
          ]
        })
        let add = res.data.data.job.map(item => ({
          value: item.count,
          name: item.job
        }))
        let data = add.slice(0, 10)
        var colors = [
          "#FF5733",
          "#33FF57",
          "#3357FF",
          "#FF33A1",
          "#9033FF",
          "#33FFF6",
          "#FFBD33",
          "#FF3333",
          "#FFFFFF"
        ];
        this.chart_4.setOption({
          //你的代码
          backgroundColor: "transparent",
          color: colors,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
            },
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['30%', '60%'],
              center: ['50%', '55%'], // 修改为居中
              avoidLabelOverlap: true,
              label: {
                color: '#fff',
                alignTo: 'labelLine',
                formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                minMargin: 5,
                edgeDistance: 10,
                lineHeight: 15,
                rich: {
                  num: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  },
                  zb: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  }
                }
              },
              labelLine: {
                length: 15,
                length2: 40,
                maxSurfaceAngle: 80
              },
              data: data
            }
          ]
        })
      })
      //消费自由度 综合收入水平 综合消费水平
      await touristsBehaviorGetConsumeFreedom(this.form).then(res => {
        var data = res.data.data.consumeFreedom.map(item => ({
          value: item.count,
          name: item.consumeFreedom
        }))
        let colors = ["#FF5733", "#3357FF", '#fff'];
        this.chart_5.setOption({
          //你的代码
          backgroundColor: "transparent",
          color: colors,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
            },
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['20%', '40%'],
              center: ['50%', '55%'], // 修改为居中
              avoidLabelOverlap: true,
              label: {
                color: '#fff',
                alignTo: 'labelLine',
                formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                minMargin: 5,
                edgeDistance: 10,
                lineHeight: 15,
                rich: {
                  num: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  },
                  zb: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  }
                }
              },
              labelLine: {
                length: 5,
                length2: 10,
                maxSurfaceAngle: 80
              },
              data: data
            }
          ]
        })
        var data1 = res.data.data.incomeLevel.map(item => ({
          value: item.count,
          name: item.incomeLevel
        }))
        this.chart_6.setOption({
          //你的代码
          backgroundColor: "transparent",
          color: colors,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
            },
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['20%', '40%'],
              center: ['50%', '55%'], // 修改为居中
              avoidLabelOverlap: true,
              label: {
                color: '#fff',
                alignTo: 'labelLine',
                formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                minMargin: 5,
                edgeDistance: 10,
                lineHeight: 15,
                rich: {
                  num: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  },
                  zb: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  }
                }
              },
              labelLine: {
                length: 5,
                length2: 10,
                maxSurfaceAngle: 80
              },
              data: data1
            }
          ]
        })
        var data2 = res.data.data.consumeLevel.map(item => ({
          value: item.count,
          name: item.consumeLevel
        }))
        this.chart_7.setOption({
          //你的代码
          backgroundColor: "transparent",
          color: colors,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
            },
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['20%', '40%'],
              center: ['50%', '55%'], // 修改为居中
              avoidLabelOverlap: true,
              label: {
                color: '#fff',
                alignTo: 'labelLine',
                formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                minMargin: 5,
                edgeDistance: 10,
                lineHeight: 15,
                rich: {
                  num: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  },
                  zb: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  }
                }
              },
              labelLine: {
                length: 5,
                length2: 10,
                maxSurfaceAngle: 80
              },
              data: data2
            }
          ]
        })
      })
      //消费品级有车比例
      await touristsBehaviorGetConsumeGradeAndCarRate(this.form).then(res => {
        let data = res.data.data.consumeGrade.map(item => item.consume_grade)
        let dataNum = res.data.data.consumeGrade.map(item => item.count)
        this.chart_8.setOption({
          backgroundColor: 'transparent',
          tooltip: {
            trigger: 'item', // 触发类型，'item' 数据项图形触发，'axis' 坐标轴触发
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 `;
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [{
            type: 'category',
            data: data,
            axisLine: {
              show: true,
              lineStyle: {
                color: "#063374",
                width: 1,
                type: "solid"
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#00c7ff",
                fontSize: "8"
              }
            },
          }],
          yAxis: [{
            type: 'value',
            axisLabel: {
              formatter: '{value}'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#00c7ff",
                width: 1,
                type: "solid"
              },
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: "#063374",
              }
            }
          }],
          series: [{
            type: 'bar',
            data: dataNum,
            barWidth: 20,
            barGap: 1, //柱子之间间距
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#00fcae'
                }, {
                  offset: 1,
                  color: '#006388'
                }]),
                opacity: 1,
              }
            }
          }]
        })
        let value1 = res.data.data.isHaveCar[0].count
        let value2 = res.data.data.isHaveCar[1].count
        let value = (value1 / value2).toFixed(2)
        console.log(value)
        this.chart_9.setOption({
          backgroundColor: 'transparent',
          title: {
            text: '有车比列',
            textStyle: {
              fontSize: 12,
              color: "rgba(255, 255, 255, 0.7)",
              rich: {
                a: {
                  fontSize: 36,
                },
              },
            },
            x: "center",
            y: "40%",
          },
          graphic: [
            {
              type: "group",
              left: "center",
              top: "50%",
              children: [
                {
                  type: "text",
                  z: 100,
                  left: "10",
                  top: "middle",
                  style: {
                    fill: "#ffffff",
                    text: value * 100 + "%",
                    font: "36px",
                    //   fontFamily: "FZHZGBJW",
                  },
                }
              ],
            },
          ],
          series: [
            {
              name: "水球图",
              type: "liquidFill",
              radius: "50%",

              data: [0.3],
              color: [
                {
                  type: "linear",
                  x: 0,
                  y: 1,
                  x2: 0,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 1,
                      color: ["rgba(2,144,255,0.4)"], // 0% 处的颜色
                    },
                    {
                      offset: 0,
                      color: ["rgba(45,175,230,0.8)"], // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              ],
              label: {
                formatter: "",
              },
              outline: {
                show: true,
                borderDistance: 0,
                itemStyle: {
                  borderColor: new echarts.graphic.LinearGradient(
                      0,
                      1,
                      0,
                      0,
                      [
                        {
                          offset: 1,
                          color: "rgba(21, 80, 161, 0.01)",
                        },
                        {
                          offset: 0,
                          color: "rgba(15, 115, 238, 0.6)",
                        },
                      ]
                  ),
                  borderWidth: 3,
                },
              },
              backgroundStyle: {
                color: new echarts.graphic.RadialGradient(0.5, 0.5, 0.5, [
                  {
                    offset: 1,
                    color: "rgba(15, 115, 238,0.3)",
                  },
                  {
                    offset: 0.95,
                    color: "rgba(15, 115, 238, 0.5)",
                  },
                  {
                    offset: 0.8,
                    color: "rgba(15, 115, 238, 0.3)",
                  },
                  {
                    offset: 0.4,
                    color: "rgba(21, 80, 161, 0.01)",
                  },
                ]),
              },
            },
          ],
        })
      })
      // 是否大学生婚姻子女阶段
      await touristsBehaviorGetMarriageAndChildRate(this.form).then(res => {
        this.ChildRate = res.data.data;
        let data = this.ChildRate.marriage[0].count / (this.ChildRate.marriage[0].count + this.ChildRate.marriage[1].count)
        let isHaveChild = this.ChildRate.isHaveChild[0].count / (this.ChildRate.isHaveChild[0].count + this.ChildRate.isHaveChild[1].count)
        this.ChildRate.marriage = data.toFixed(2) * 100
        this.ChildRate.isHaveChild = isHaveChild.toFixed(2) * 100
        const basicColors = [
          ['#159AFF', 'rgba(0, 58, 255, 0.0001)'],
          ['#26BFBF', 'rgba(36, 190, 190, 0.0001)'],
          ['#A0C2E4', 'rgba(83, 105, 128, 0.0001)'],
          ['#FFB515', 'rgba(255, 140, 0, 0.0001)'],
          ['#43CBFF', '#9870CC'],
          ['#FCCF31', '#F55555'],
          ['#F761A1', '#8C1BAB'],
          ['#81FBB8', '#28C76F']
        ]

        function genLinearGradient(colors) {
          const color = {
            type: 'linear',
            x: 1,
            y: 0,
            x2: 0,
            y2: 0,
            colorStops: [
              {
                offset: 0,
                color: colors[0] // 0%处的颜色
              },
              {
                offset: 1,
                color: colors[1] // 100%处的颜色
              }
            ],
            global: false
          }
          return color
        }

        const dataName = res.data.data.childStage.map(item => item.child_stage)
        const dataList = res.data.data.childStage.map(item => item.count)
        this.chart_10.setOption({
          backgroundColor: "transparent",
          grid: {
            left: '12%',
            top: '5%',
            bottom: '12%',
            right: '8%'
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              lineStyle: {
                color: 'rgba(255,255,255,0.8)'
              }
            }
          },
          xAxis: {
            data: dataName,
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(255, 129, 109, 0.1)',
                width: 1 // 这里是为了突出显示加上的
              }
            },
            axisLabel: {
              textStyle: {
                color: '#fff',
                fontSize: 12
              }
            }
          },
          yAxis: [{
            splitNumber: 2,
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(255, 129, 109, 0.1)',
                width: 1 // 这里是为了突出显示加上的
              }
            },
            axisLabel: {
              textStyle: {
                color: '#fff'
              }
            },
            splitArea: {
              areaStyle: {
                color: 'rgba(255,255,255,.5)'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255, 129, 109, 0.1)',
                width: 0.5,
                type: 'dashed'
              }
            }
          }
          ],
          series: [{
            name: 'hill',
            type: 'pictorialBar',
            barCategoryGap: '0%',
            symbol: 'path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z',
            label: {
              show: false,
              position: 'top',
              distance: 15,
              color: '#FFF6B7',
              fontWeight: 'bolder',
              fontSize: 20,
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  return genLinearGradient(basicColors[params.dataIndex])
                }
              },
              emphasis: {
                opacity: 1
              }
            },
            data: dataList,
            z: 10
          }]
        })

      })
      //手机运营商
      await touristsBehaviorGetServiceAndBrandRate(this.form).then(res => {
        let data = res.data.data.service.map(item => ({
          value: item.count,
          name: item.service
        }))
        let color = ["#FF5733", "#3357FF", '#a4fd05'];
        this.chart_11.setOption({
          //你的代码
          backgroundColor: "transparent",
          color: color,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
            },
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['30%', '60%'],
              center: ['50%', '55%'], // 修改为居中
              avoidLabelOverlap: true,
              label: {
                color: '#fff',
                alignTo: 'labelLine',
                formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                minMargin: 5,
                edgeDistance: 10,
                lineHeight: 15,
                rich: {
                  num: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  },
                  zb: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  }
                }
              },
              labelLine: {
                length: 15,
                length2: 40,
                maxSurfaceAngle: 80
              },
              data: data
            }
          ]
        })
        let dataAge = res.data.data.brand.map(item => item.phone_brand)
        let dataAgeNum = res.data.data.brand.map(item => item.count)
        this.chart_12.setOption({
          backgroundColor: 'transparent',
          tooltip: {
            trigger: 'item', // 触发类型，'item' 数据项图形触发，'axis' 坐标轴触发
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 `;
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [{
            type: 'category',
            data: dataAge,
            axisLine: {
              show: true,
              lineStyle: {
                color: "#063374",
                width: 1,
                type: "solid"
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#00c7ff",
                fontSize: "8"
              }
            },
          }],
          yAxis: [{
            type: 'value',
            axisLabel: {
              formatter: '{value}'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#00c7ff",
                width: 1,
                type: "solid"
              },
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: "#063374",
              }
            }
          }],
          series: [{
            type: 'bar',
            data: dataAgeNum,
            barWidth: 20,
            barGap: 1, //柱子之间间距
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#00fcae'
                }, {
                  offset: 1,
                  color: '#006388'
                }]),
                opacity: 1,
              }
            }
          }]
        })
      })

      if (this.currentDataIndex == 2) {
        // 出行方式
        await travelPerformanceGetTransportationRate(this.form).then(res => {
          let dataAge = res.data.data.map(item => item.transportation)
          let dataAgeNum = res.data.data.map(item => item.count)
          this.chart_2_2.setOption({
            backgroundColor: 'transparent',
            tooltip: {
              trigger: 'item', // 触发类型，'item' 数据项图形触发，'axis' 坐标轴触发
              show: true,
              backgroundColor: 'rgba(13,5,30,.6)',
              borderWidth: 1,
              borderColor: '#32A1FF',
              padding: 5,
              textStyle: {
                color: '#fff'
              },
              confine: true,
              formatter(params) {
                if (params.name === '') {
                  return '';
                }
                return `${params.name} : ${params.value}人 `;
              },
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: [{
              type: 'category',
              data: dataAge,
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#063374",
                  width: 1,
                  type: "solid"
                }
              },
              axisTick: {
                show: false
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: "#00c7ff",
                  fontSize: "8"
                }
              },
            }],
            yAxis: [{
              type: 'value',
              axisLabel: {
                formatter: '{value}'
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: "#00c7ff",
                  width: 1,
                  type: "solid"
                },
              },
              axisTick: {
                show: false
              },
              splitLine: {
                lineStyle: {
                  color: "#063374",
                }
              }
            }],
            series: [{
              type: 'bar',
              data: dataAgeNum,
              barWidth: 20,
              barGap: 1, //柱子之间间距
              itemStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#00fcae'
                  }, {
                    offset: 1,
                    color: '#006388'
                  }]),
                  opacity: 1,
                }
              }
            }]
          })
        })
        // 旅游满意度
        await travelPerformanceGetTravelSatisfaction(this.form).then(res => {
          let data = res.data.data.satisfaction.map(item => ({
            value: item.count,
            name: item.satisfaction
          }))
          let color = ["#FF5733", "#3357FF",];
          this.chart_2_3.setOption({
            //你的代码
            backgroundColor: "transparent",
            color: color,
            tooltip: {
              show: true,
              backgroundColor: 'rgba(13,5,30,.6)',
              borderWidth: 1,
              borderColor: '#32A1FF',
              padding: 5,
              textStyle: {
                color: '#fff'
              },
              confine: true,
              formatter(params) {
                if (params.name === '') {
                  return '';
                }
                return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
              },
            },
            series: [
              {
                name: '',
                type: 'pie',
                radius: ['30%', '60%'],
                center: ['50%', '55%'], // 修改为居中
                avoidLabelOverlap: true,
                label: {
                  color: '#fff',
                  alignTo: 'labelLine',
                  formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                  minMargin: 5,
                  edgeDistance: 10,
                  lineHeight: 15,
                  rich: {
                    num: {
                      fontSize: 14,
                      color: '#FFFFFF'
                    },
                    zb: {
                      fontSize: 14,
                      color: '#FFFFFF'
                    }
                  }
                },
                labelLine: {
                  length: 15,
                  length2: 40,
                  maxSurfaceAngle: 80
                },
                data: data
              }
            ]
          })
        })
        // 餐饮类型偏好
        await travelPerformanceGetCateringTop10(this.form).then(res => {
          this.getCatering = res.data.data
          let data = res.data.data.map(item => ({
            value: item.count,
            name: item.catering
          }))
          let color = generateRandomColors(data.length)
          this.chart_2_4.setOption({
            //你的代码
            backgroundColor: "transparent",
            color: color,
            tooltip: {
              show: true,
              backgroundColor: 'rgba(13,5,30,.6)',
              borderWidth: 1,
              borderColor: '#32A1FF',
              padding: 5,
              textStyle: {
                color: '#fff'
              },
              confine: true,
              formatter(params) {
                if (params.name === '') {
                  return '';
                }
                return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
              },
            },
            series: [
              {
                name: '',
                type: 'pie',
                radius: ['30%', '60%'],
                center: ['50%', '55%'], // 修改为居中
                avoidLabelOverlap: true,
                label: {
                  color: '#fff',
                  alignTo: 'labelLine',
                  formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                  minMargin: 5,
                  edgeDistance: 10,
                  lineHeight: 15,
                  rich: {
                    num: {
                      fontSize: 14,
                      color: '#FFFFFF'
                    },
                    zb: {
                      fontSize: 14,
                      color: '#FFFFFF'
                    }
                  }
                },
                labelLine: {
                  length: 15,
                  length2: 40,
                  maxSurfaceAngle: 80
                },
                data: data
              }
            ]
          })
        })
        // 酒店品牌
        await travelPerformanceGetHotelTop10(this.form).then(res => {
          let data = res.data.data.hotelType.map(item => ({
            value: item.count,
            name: item.hotel_type
          }))
          this.getHotel = res.data.data
          let color = generateRandomColors(data.length)
          this.chart_2_5.setOption({
            //你的代码
            backgroundColor: "transparent",
            color: color,
            tooltip: {
              show: true,
              backgroundColor: 'rgba(13,5,30,.6)',
              borderWidth: 1,
              borderColor: '#32A1FF',
              padding: 5,
              textStyle: {
                color: '#fff'
              },
              confine: true,
              formatter(params) {
                if (params.name === '') {
                  return '';
                }
                return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
              },
            },
            series: [
              {
                name: '',
                type: 'pie',
                radius: ['30%', '60%'],
                center: ['50%', '55%'], // 修改为居中
                avoidLabelOverlap: true,
                label: {
                  color: '#fff',
                  alignTo: 'labelLine',
                  formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                  minMargin: 5,
                  edgeDistance: 10,
                  lineHeight: 15,
                  rich: {
                    num: {
                      fontSize: 14,
                      color: '#FFFFFF'
                    },
                    zb: {
                      fontSize: 14,
                      color: '#FFFFFF'
                    }
                  }
                },
                labelLine: {
                  length: 15,
                  length2: 40,
                  maxSurfaceAngle: 80
                },
                data: data
              }
            ]
          })
        })
      }
      if (this.currentDataIndex == 3) {
        //应用时长频率
        await appPerformanceGetAppUseFrequenceAndTime(this.form).then(res => {
          let data = res.data.data.appUseTime.map(item => ({
            value: item.count,
            name: item.app_use_time
          }))
          let color = ["#FF5733", "#3357FF",];
          let data1 = res.data.data.appUseFrequence.map(item => ({
            value: item.count,
            name: item.app_use_frequence
          }))
          let color1 = ["#FF5733", "#3357FF",];
          this.chart_2_6.setOption({
            //你的代码
            backgroundColor: "transparent",
            color: color,
            tooltip: {
              show: true,
              backgroundColor: 'rgba(13,5,30,.6)',
              borderWidth: 1,
              borderColor: '#32A1FF',
              padding: 5,
              textStyle: {
                color: '#fff'
              },
              confine: true,
              formatter(params) {
                if (params.name === '') {
                  return '';
                }
                return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
              },
            },
            series: [
              {
                name: '',
                type: 'pie',
                radius: ['20%', '40%'],
                center: ['50%', '55%'], // 修改为居中
                avoidLabelOverlap: true,
                label: {
                  color: '#fff',
                  alignTo: 'labelLine',
                  formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                  minMargin: 5,
                  edgeDistance: 10,
                  lineHeight: 15,
                  rich: {
                    num: {
                      fontSize: 14,
                      color: '#FFFFFF'
                    },
                    zb: {
                      fontSize: 14,
                      color: '#FFFFFF'
                    }
                  }
                },
                labelLine: {
                  length: 15,
                  length2: 40,
                  maxSurfaceAngle: 80
                },
                data: data
              }
            ]
          })
          this.chart_2_7.setOption({
            //你的代码
            backgroundColor: "transparent",
            color: color1,
            tooltip: {
              show: true,
              backgroundColor: 'rgba(13,5,30,.6)',
              borderWidth: 1,
              borderColor: '#32A1FF',
              padding: 5,
              textStyle: {
                color: '#fff'
              },
              confine: true,
              formatter(params) {
                if (params.name === '') {
                  return '';
                }
                return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
              },
            },
            series: [
              {
                name: '',
                type: 'pie',
                radius: ['20%', '40%'],
                center: ['50%', '55%'], // 修改为居中
                avoidLabelOverlap: true,
                label: {
                  color: '#fff',
                  alignTo: 'labelLine',
                  formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                  minMargin: 5,
                  edgeDistance: 10,
                  lineHeight: 15,
                  rich: {
                    num: {
                      fontSize: 14,
                      color: '#FFFFFF'
                    },
                    zb: {
                      fontSize: 14,
                      color: '#FFFFFF'
                    }
                  }
                },
                labelLine: {
                  length: 15,
                  length2: 40,
                  maxSurfaceAngle: 80
                },
                data: data1
              }
            ]
          })
        })
        //app安装top
        await appPerformanceGetAppInstallTop(this.form).then(res => {
          let radarData = res.data.data.app_stats.map(item => ({
            name: item.app_name,
            value: item.user_count
          }))
          let valueList = radarData.map((it) => {
            return it.value;
          });
          let vlueMax = Math.max(...valueList);
          vlueMax = vlueMax + vlueMax * 0.2;
          let indicator = radarData.map((it) => {
            return {name: it.name, max: vlueMax};
          });
          let seriesData = [{value: valueList}];
          this.chart_2_8.setOption({
            backgroundColor: 'transparent',
            title: {
              text: "",
              x: "center",
              textStyle: {
                fontSize: 12
              }
            },
            grid: {
              top: '10%'
            },
            tooltip: {
              show: true,
              trigger: "item"
            },
            radar: {
              center: ["50%", "50%"],
              radius: "70%",
              shape: "circle",
              splitArea: {
                areaStyle: {
                  color: ["transparent"]
                }
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: "rgba(34,50,129,1)"
                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: "rgba(34,50,129,1)"
                }
              },
              name: {
                textStyle: {
                  color: 'white',
                  fontSize: 14
                },
              },
              indicator: indicator
            },
            series: [{
              type: "radar",
              name: '月度风险指数',
              symbol: "circle",
              symbolSize: 4,
              itemStyle: {
                normal: {
                  color: 'rgba(059, 114, 230,1)',
                  borderColor: "rgba(059, 114, 230,0.5)",
                  borderWidth: 6
                }
              },
              areaStyle: {
                normal: {
                  color: "rgba(059, 114, 230,0.5)"
                }
              },
              lineStyle: {
                normal: {
                  color: "rgba(059, 114, 230,1)",
                  width: 2,
                }
              },
              label: {

                normal: {
                  show: true,
                  color: 'white',
                  position: 'top'
                }
              },
              data: seriesData
            }]
          })
        })
      }
      loading.close();
    },
    // 右上角触发
    dataIndexChoose(value) {
      this.currentDataIndex = value
      if (value == 2) {
        const loading = this.$loading({
          lock: true,
          text: '加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 1)'
        });
        this.$nextTick(async () => {
          await this.getActiveCityTop()  //游客活跃城市TOP20
          await this.myChartTravel()   //  出行方式偏好
          await this.TravelSatisfaction() // 旅游满意度
          await this.getCateringFaction()   // 餐饮类型
          await this.getHotelFaction()  // 酒店品牌
          window.addEventListener('resize', this.handleResize);
          loading.close()
        })
      }
      if (value == 3) {
        const loading = this.$loading({
          lock: true,
          text: '加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 1)'
        });
        this.$nextTick(async () => {
          await appPerformanceGetAppTypeList().then(res => {
            this.getAppTypeList = res.data.data
          })
          // 默认加载三个app应用
          await appPerformanceGetAppList().then(res => {
            this.getAppList = res.data.data
          })
          await this.getAppUseFrequence()  // 应用时长频率
          await this.getAppInstallTop()
          loading.close()
        })
      }
    },
     getTime(value) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.form.startTime = value[0]
      this.form.endTime = value[1]
      // 选择时间后触发新的 性别年龄
         touristsBehaviorGetGenderAndAgeRate(this.form).then(res => {
        let data = res.data.data.gender.map(item => ({
          value: item.count,
          name: item.gender
        }))
        let color = ["#FF5733", "#3357FF",];
        let dataAge = res.data.data.age.map(item => item.age_group)
        let dataAgeNum = res.data.data.age.map(item => item.count)
        this.Chart_1.setOption({
          //你的代码
          backgroundColor: "transparent",
          color: color,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
            },
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['30%', '60%'],
              center: ['50%', '55%'], // 修改为居中
              avoidLabelOverlap: true,
              label: {
                color: '#fff',
                alignTo: 'labelLine',
                formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                minMargin: 5,
                edgeDistance: 10,
                lineHeight: 15,
                rich: {
                  num: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  },
                  zb: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  }
                }
              },
              labelLine: {
                length: 15,
                length2: 40,
                maxSurfaceAngle: 80
              },
              data: data
            }
          ]
        })
        this.Chart_2.setOption({
          backgroundColor: 'transparent',
          tooltip: {
            trigger: 'item', // 触发类型，'item' 数据项图形触发，'axis' 坐标轴触发
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 `;
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [{
            type: 'category',
            data: dataAge,
            axisLine: {
              show: true,
              lineStyle: {
                color: "#063374",
                width: 1,
                type: "solid"
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#00c7ff",
                fontSize: "8"
              }
            },
          }],
          yAxis: [{
            type: 'value',
            axisLabel: {
              formatter: '{value}'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#00c7ff",
                width: 1,
                type: "solid"
              },
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: "#063374",
              }
            }
          }],
          series: [{
            type: 'bar',
            data: dataAgeNum,
            barWidth: 20,
            barGap: 1, //柱子之间间距
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#00fcae'
                }, {
                  offset: 1,
                  color: '#006388'
                }]),
                opacity: 1,
              }
            }
          }]
        })
      })
      // 选择时间后触发新的 学历职业
       touristsBehaviorGetEducationAndJobRate(this.form).then(res => {
        var dataList = res.data.data.education.map(item => item.count);
        let indicator = res.data.data.education.map(item => ({
          name: item.education,
        }))
        this.chart_3.setOption({
          backgroundColor: 'transparent',
          color: ['#DC0606', '#DCDC06'],
          tooltip: {
            show: true // 弹层数据去掉
          },
          legend: {
            show: false,
          },
          radar: {
            center: ['50%', '50%'], // 外圆的位置
            radius: '55%',
            name: {
              textStyle: {
                color: '#fff',
                fontSize: 16,
                fontWeight: 400,
                fontFamily: 'PingFangSC-Regular,PingFang SC',
                fontStyle: 'normal',
              }
            },
            // TODO:
            indicator: indicator,
            splitArea: {
              // 坐标轴在 grid 区域中的分隔区域，默认不显示。
              show: true,
              areaStyle: {
                // 分隔区域的样式设置。
                color: ['#1c2330'] // 分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色。
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                type: "dashed",
                color: '#603737'
              }
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: '#603737', // 分隔线颜色
                width: 1 // 分隔线线宽
              }
            }
          },
          series: [
            {
              type: 'radar',
              symbolSize: 6,
              data: [
                {
                  // TODO:
                  value: dataList,
                  itemStyle: {
                    borderColor: 'rgba(220, 220, 6, 1)',
                    color: '#fbf9b4',
                    borderWidth: 2
                  },
                  lineStyle: {
                    normal: {
                      width: 1,
                      color: 'rgba(220, 220, 6, 1)',
                    }
                  },
                  areaStyle: {
                    normal: {
                      color: {
                        type: 'radial',
                        x: 0.5,
                        y: 0.5,
                        r: 0.5,
                        colorStops: [{
                          offset: 0, color: 'rgba(255, 127,0, 0.14)' // 0% 处的颜色
                        },
                          {
                            offset: 0.15, color: 'rgba(255, 127,0, 0.14)' // 100% 处的颜色
                          },
                          {
                            offset: 0.75, color: 'rgba(2255, 127,0, 0.4)' // 100% 处的颜色
                          },
                          {
                            offset: 1, color: 'rgba(255, 127,0, 0.5)' // 100% 处的颜色
                          }],
                        global: false // 缺省为 false
                      }
                    }
                  },
                }
              ]
            }
          ]
        })
        let add = res.data.data.job.map(item => ({
          value: item.count,
          name: item.job
        }))
        let data = add.slice(0, 10)
        var colors = [
          "#FF5733",
          "#33FF57",
          "#3357FF",
          "#FF33A1",
          "#9033FF",
          "#33FFF6",
          "#FFBD33",
          "#FF3333",
          "#FFFFFF"
        ];
        this.chart_4.setOption({
          //你的代码
          backgroundColor: "transparent",
          color: colors,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
            },
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['30%', '60%'],
              center: ['50%', '55%'], // 修改为居中
              avoidLabelOverlap: true,
              label: {
                color: '#fff',
                alignTo: 'labelLine',
                formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                minMargin: 5,
                edgeDistance: 10,
                lineHeight: 15,
                rich: {
                  num: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  },
                  zb: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  }
                }
              },
              labelLine: {
                length: 15,
                length2: 40,
                maxSurfaceAngle: 80
              },
              data: data
            }
          ]
        })
      })
      // 选择时间后触发新的消费自由度 综合收入水平 综合消费水平
       touristsBehaviorGetConsumeFreedom(this.form).then(res => {
        var data = res.data.data.consumeFreedom.map(item => ({
          value: item.count,
          name: item.consumeFreedom
        }))
        let colors = ["#FF5733", "#3357FF", '#fff'];
        this.chart_5.setOption({
          //你的代码
          backgroundColor: "transparent",
          color: colors,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
            },
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['20%', '40%'],
              center: ['50%', '55%'], // 修改为居中
              avoidLabelOverlap: true,
              label: {
                color: '#fff',
                alignTo: 'labelLine',
                formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                minMargin: 5,
                edgeDistance: 10,
                lineHeight: 15,
                rich: {
                  num: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  },
                  zb: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  }
                }
              },
              labelLine: {
                length: 5,
                length2: 10,
                maxSurfaceAngle: 80
              },
              data: data
            }
          ]
        })
        var data1 = res.data.data.incomeLevel.map(item => ({
          value: item.count,
          name: item.incomeLevel
        }))
        this.chart_6.setOption({
          //你的代码
          backgroundColor: "transparent",
          color: colors,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
            },
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['20%', '40%'],
              center: ['50%', '55%'], // 修改为居中
              avoidLabelOverlap: true,
              label: {
                color: '#fff',
                alignTo: 'labelLine',
                formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                minMargin: 5,
                edgeDistance: 10,
                lineHeight: 15,
                rich: {
                  num: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  },
                  zb: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  }
                }
              },
              labelLine: {
                length: 5,
                length2: 10,
                maxSurfaceAngle: 80
              },
              data: data1
            }
          ]
        })
        var data2 = res.data.data.consumeLevel.map(item => ({
          value: item.count,
          name: item.consumeLevel
        }))
        this.chart_7.setOption({
          //你的代码
          backgroundColor: "transparent",
          color: colors,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
            },
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['20%', '40%'],
              center: ['50%', '55%'], // 修改为居中
              avoidLabelOverlap: true,
              label: {
                color: '#fff',
                alignTo: 'labelLine',
                formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                minMargin: 5,
                edgeDistance: 10,
                lineHeight: 15,
                rich: {
                  num: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  },
                  zb: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  }
                }
              },
              labelLine: {
                length: 5,
                length2: 10,
                maxSurfaceAngle: 80
              },
              data: data2
            }
          ]
        })
      })
      // 选择后触发新的消费品级 有车比例
       touristsBehaviorGetConsumeGradeAndCarRate(this.form).then(res => {
        let data = res.data.data.consumeGrade.map(item => item.consume_grade)
        let dataNum = res.data.data.consumeGrade.map(item => item.count)
        this.chart_8.setOption({
          backgroundColor: 'transparent',
          tooltip: {
            trigger: 'item', // 触发类型，'item' 数据项图形触发，'axis' 坐标轴触发
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 `;
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [{
            type: 'category',
            data: data,
            axisLine: {
              show: true,
              lineStyle: {
                color: "#063374",
                width: 1,
                type: "solid"
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#00c7ff",
                fontSize: "8"
              }
            },
          }],
          yAxis: [{
            type: 'value',
            axisLabel: {
              formatter: '{value}'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#00c7ff",
                width: 1,
                type: "solid"
              },
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: "#063374",
              }
            }
          }],
          series: [{
            type: 'bar',
            data: dataNum,
            barWidth: 20,
            barGap: 1, //柱子之间间距
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#00fcae'
                }, {
                  offset: 1,
                  color: '#006388'
                }]),
                opacity: 1,
              }
            }
          }]
        })
        let value1 = res.data.data.isHaveCar[0].count
        let value2 = res.data.data.isHaveCar[1].count
        let value = (value1 / value2).toFixed(2)
        console.log(value)
        this.chart_9.setOption({
          backgroundColor: 'transparent',
          title: {
            text: '有车比列',
            textStyle: {
              fontSize: 12,
              color: "rgba(255, 255, 255, 0.7)",
              rich: {
                a: {
                  fontSize: 36,
                },
              },
            },
            x: "center",
            y: "40%",
          },
          graphic: [
            {
              type: "group",
              left: "center",
              top: "50%",
              children: [
                {
                  type: "text",
                  z: 100,
                  left: "10",
                  top: "middle",
                  style: {
                    fill: "#ffffff",
                    text: value * 100 + "%",
                    font: "36px",
                    //   fontFamily: "FZHZGBJW",
                  },
                }
              ],
            },
          ],
          series: [
            {
              name: "水球图",
              type: "liquidFill",
              radius: "50%",

              data: [0.3],
              color: [
                {
                  type: "linear",
                  x: 0,
                  y: 1,
                  x2: 0,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 1,
                      color: ["rgba(2,144,255,0.4)"], // 0% 处的颜色
                    },
                    {
                      offset: 0,
                      color: ["rgba(45,175,230,0.8)"], // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              ],
              label: {
                formatter: "",
              },
              outline: {
                show: true,
                borderDistance: 0,
                itemStyle: {
                  borderColor: new echarts.graphic.LinearGradient(
                      0,
                      1,
                      0,
                      0,
                      [
                        {
                          offset: 1,
                          color: "rgba(21, 80, 161, 0.01)",
                        },
                        {
                          offset: 0,
                          color: "rgba(15, 115, 238, 0.6)",
                        },
                      ]
                  ),
                  borderWidth: 3,
                },
              },
              backgroundStyle: {
                color: new echarts.graphic.RadialGradient(0.5, 0.5, 0.5, [
                  {
                    offset: 1,
                    color: "rgba(15, 115, 238,0.3)",
                  },
                  {
                    offset: 0.95,
                    color: "rgba(15, 115, 238, 0.5)",
                  },
                  {
                    offset: 0.8,
                    color: "rgba(15, 115, 238, 0.3)",
                  },
                  {
                    offset: 0.4,
                    color: "rgba(21, 80, 161, 0.01)",
                  },
                ]),
              },
            },
          ],
        })
      })
      // 选择时间大学生婚姻子女阶段
       touristsBehaviorGetMarriageAndChildRate(this.form).then(res => {
        this.ChildRate = res.data.data;
        let data = this.ChildRate.marriage[0].count / (this.ChildRate.marriage[0].count + this.ChildRate.marriage[1].count)
        let isHaveChild = this.ChildRate.isHaveChild[0].count / (this.ChildRate.isHaveChild[0].count + this.ChildRate.isHaveChild[1].count)
        this.ChildRate.marriage = data.toFixed(2) * 100
        this.ChildRate.isHaveChild = isHaveChild.toFixed(2) * 100
        const basicColors = [
          ['#159AFF', 'rgba(0, 58, 255, 0.0001)'],
          ['#26BFBF', 'rgba(36, 190, 190, 0.0001)'],
          ['#A0C2E4', 'rgba(83, 105, 128, 0.0001)'],
          ['#FFB515', 'rgba(255, 140, 0, 0.0001)'],
          ['#43CBFF', '#9870CC'],
          ['#FCCF31', '#F55555'],
          ['#F761A1', '#8C1BAB'],
          ['#81FBB8', '#28C76F']
        ]

        function genLinearGradient(colors) {
          const color = {
            type: 'linear',
            x: 1,
            y: 0,
            x2: 0,
            y2: 0,
            colorStops: [
              {
                offset: 0,
                color: colors[0] // 0%处的颜色
              },
              {
                offset: 1,
                color: colors[1] // 100%处的颜色
              }
            ],
            global: false
          }
          return color
        }

        const dataName = res.data.data.childStage.map(item => item.child_stage)
        const dataList = res.data.data.childStage.map(item => item.count)
        this.chart_10.setOption({
          backgroundColor: "transparent",
          grid: {
            left: '12%',
            top: '5%',
            bottom: '12%',
            right: '8%'
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              lineStyle: {
                color: 'rgba(255,255,255,0.8)'
              }
            }
          },
          xAxis: {
            data: dataName,
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(255, 129, 109, 0.1)',
                width: 1 // 这里是为了突出显示加上的
              }
            },
            axisLabel: {
              textStyle: {
                color: '#fff',
                fontSize: 12
              }
            }
          },
          yAxis: [{
            splitNumber: 2,
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(255, 129, 109, 0.1)',
                width: 1 // 这里是为了突出显示加上的
              }
            },
            axisLabel: {
              textStyle: {
                color: '#fff'
              }
            },
            splitArea: {
              areaStyle: {
                color: 'rgba(255,255,255,.5)'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255, 129, 109, 0.1)',
                width: 0.5,
                type: 'dashed'
              }
            }
          }
          ],
          series: [{
            name: 'hill',
            type: 'pictorialBar',
            barCategoryGap: '0%',
            symbol: 'path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z',
            label: {
              show: false,
              position: 'top',
              distance: 15,
              color: '#FFF6B7',
              fontWeight: 'bolder',
              fontSize: 20,
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  return genLinearGradient(basicColors[params.dataIndex])
                }
              },
              emphasis: {
                opacity: 1
              }
            },
            data: dataList,
            z: 10
          }]
        })

      })
      // 选择时间手机运营商
       touristsBehaviorGetServiceAndBrandRate(this.form).then(res => {
        let data = res.data.data.service.map(item => ({
          value: item.count,
          name: item.service
        }))
        let color = ["#FF5733", "#3357FF", '#a4fd05'];
        this.chart_11.setOption({
          //你的代码
          backgroundColor: "transparent",
          color: color,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
            },
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['30%', '60%'],
              center: ['50%', '55%'], // 修改为居中
              avoidLabelOverlap: true,
              label: {
                color: '#fff',
                alignTo: 'labelLine',
                formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                minMargin: 5,
                edgeDistance: 10,
                lineHeight: 15,
                rich: {
                  num: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  },
                  zb: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  }
                }
              },
              labelLine: {
                length: 15,
                length2: 40,
                maxSurfaceAngle: 80
              },
              data: data
            }
          ]
        })
        let dataAge = res.data.data.brand.map(item => item.phone_brand)
        let dataAgeNum = res.data.data.brand.map(item => item.count)
        this.chart_12.setOption({
          backgroundColor: 'transparent',
          tooltip: {
            trigger: 'item', // 触发类型，'item' 数据项图形触发，'axis' 坐标轴触发
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 `;
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [{
            type: 'category',
            data: dataAge,
            axisLine: {
              show: true,
              lineStyle: {
                color: "#063374",
                width: 1,
                type: "solid"
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#00c7ff",
                fontSize: "8"
              }
            },
          }],
          yAxis: [{
            type: 'value',
            axisLabel: {
              formatter: '{value}'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#00c7ff",
                width: 1,
                type: "solid"
              },
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: "#063374",
              }
            }
          }],
          series: [{
            type: 'bar',
            data: dataAgeNum,
            barWidth: 20,
            barGap: 1, //柱子之间间距
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#00fcae'
                }, {
                  offset: 1,
                  color: '#006388'
                }]),
                opacity: 1,
              }
            }
          }]
        })
      })
      // 游客活跃城市
       travelPerformanceGetActiveCityTop20(this.form).then(res => {
        this.data = res.data.data
        this.data.forEach((item, index) => {
          item.index = index + 1;
        });
        var geoCoordMap = {},
            data = [];
        China.features.forEach(function (item) {
          var name = item.properties.name,
              cp = item.properties.center;
          if (cp) {
            geoCoordMap[name] = cp; // 地区经纬度
            data.push({
              name: name,
              value: cp.concat(Math.round(Math.random() * 100))
            })
          }
        });
        let data1 = [
          {
            name: "北京",
            value: [116.405285, 39.904989, 116.405285, 39.904989, 49]
          },
          {
            name: "天津",
            value: [117.190182, 39.125596, 117.190182, 39.125596, 18]
          },
          {
            name: "河北",
            value: [114.502461, 38.045474, 114.502461, 38.045474, 97]
          },
          {
            name: "山西",
            value: [112.549248, 37.857014, 112.549248, 37.857014, 85]
          },
          {
            name: "内蒙古",
            value: [111.670801, 40.818311, 111.670801, 40.818311, 83]
          },

        ]
        echarts.registerMap('china', China);
        this.chart_2_1.setOption({
          tooltip: {
            trigger: "item",
            formatter: function (params) {
              if (params.seriesType == "scatter") {
                return "线路：" + params.data.name + "" + params.data.value[2];
              } else if (params.seriesType == "lines") {
                return (
                    params.data.fromName +
                    ">" +
                    params.data.toName +
                    "<br />" +
                    params.data.value
                );
              }
            }
          },
          visualMap: {
            show: false,
            min: 0,
            max: 100,
            left: 'left',
            top: 'bottom',
            text: ['高', '低'], // 文本，默认为数值文本
            calculable: true,
            seriesIndex: [1],
            inRange: {
              color: ['#004693'] // 蓝绿
            }
          },
          geo: {
            show: true,
            map: 'china',
            roam: true,
            zoom: 1.25,
            label: {
              show: true,
              padding: 4,
              color: '#ddd',
              fontFamily: 'pf-zh'
            },
            itemStyle: {
              normal: {
                areaColor: '#031525',
                borderWidth: 1,
                borderColor: '#00CFFC',
              },
              emphasis: {
                areaColor: '#2B91B7',
              }
            }
          },
          series: [
            {
              type: 'map',
              map: 'china',
              geoIndex: 0,
              roam: true,
              aspectScale: 0.75, //长宽比
              showLegendSymbol: false, // 存在legend时显示
              label: {
                normal: {
                  show: true
                },
                emphasis: {
                  show: false,
                  textStyle: {
                    color: '#fff'
                  }
                }
              },
              itemStyle: {
                normal: {
                  areaColor: '#031525',
                  borderColor: '#3B5077'
                },
                emphasis: {
                  areaColor: '#2B91B7'
                }
              },
              animation: false,
              data: data1
            },
            // 散点
            {
              name: '散点',
              type: 'scatter',
              coordinateSystem: 'geo',
              symbolSize: 5,
              label: {
                normal: {
                  show: false,
                  position: 'right'
                }
              },
              itemStyle: {
                normal: {
                  color: 'white'
                }
              },
              zlevel: 10,
              data: data1
            },
            {
              name: '点',
              type: 'scatter',
              coordinateSystem: 'geo',
              symbol: 'pin', //气泡
              symbolSize: function () {
                return 40
              },
              label: {
                show: true,
                formatter: function (parm) {
                  return parm.value[4]
                },
                textStyle: {
                  color: '#0f1325'
                }
              },
              itemStyle: {
                color: '#fff' //标志颜色
              },
              zlevel: 6,
              data: data1
            },
          ]
        })
      })
      // 出行方式
       travelPerformanceGetTransportationRate(this.form).then(res => {
        let dataAge = res.data.data.map(item => item.transportation)
        let dataAgeNum = res.data.data.map(item => item.count)
        this.chart_2_2.setOption({
          backgroundColor: 'transparent',
          tooltip: {
            trigger: 'item', // 触发类型，'item' 数据项图形触发，'axis' 坐标轴触发
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 `;
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [{
            type: 'category',
            data: dataAge,
            axisLine: {
              show: true,
              lineStyle: {
                color: "#063374",
                width: 1,
                type: "solid"
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#00c7ff",
                fontSize: "8"
              }
            },
          }],
          yAxis: [{
            type: 'value',
            axisLabel: {
              formatter: '{value}'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#00c7ff",
                width: 1,
                type: "solid"
              },
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: "#063374",
              }
            }
          }],
          series: [{
            type: 'bar',
            data: dataAgeNum,
            barWidth: 20,
            barGap: 1, //柱子之间间距
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#00fcae'
                }, {
                  offset: 1,
                  color: '#006388'
                }]),
                opacity: 1,
              }
            }
          }]
        })
      })
      // 旅游满意度
       travelPerformanceGetTravelSatisfaction(this.form).then(res => {
        let data = res.data.data.satisfaction.map(item => ({
          value: item.count,
          name: item.satisfaction
        }))
        let color = ["#FF5733", "#3357FF",];
        this.chart_2_3.setOption({
          //你的代码
          backgroundColor: "transparent",
          color: color,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
            },
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['30%', '60%'],
              center: ['50%', '55%'], // 修改为居中
              avoidLabelOverlap: true,
              label: {
                color: '#fff',
                alignTo: 'labelLine',
                formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                minMargin: 5,
                edgeDistance: 10,
                lineHeight: 15,
                rich: {
                  num: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  },
                  zb: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  }
                }
              },
              labelLine: {
                length: 15,
                length2: 40,
                maxSurfaceAngle: 80
              },
              data: data
            }
          ]
        })
      })
      // 餐饮类型
       travelPerformanceGetCateringTop10(this.form).then(res => {
        this.getCatering = res.data.data
        let data = res.data.data.map(item => ({
          value: item.count,
          name: item.catering
        }))
        let color = generateRandomColors(data.length)
        this.chart_2_4.setOption({
          //你的代码
          backgroundColor: "transparent",
          color: color,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
            },
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['30%', '60%'],
              center: ['50%', '55%'], // 修改为居中
              avoidLabelOverlap: true,
              label: {
                color: '#fff',
                alignTo: 'labelLine',
                formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                minMargin: 5,
                edgeDistance: 10,
                lineHeight: 15,
                rich: {
                  num: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  },
                  zb: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  }
                }
              },
              labelLine: {
                length: 15,
                length2: 40,
                maxSurfaceAngle: 80
              },
              data: data
            }
          ]
        })
      })
      // 酒店品牌
       travelPerformanceGetHotelTop10(this.form).then(res => {
        let data = res.data.data.hotelType.map(item => ({
          value: item.count,
          name: item.hotel_type
        }))
        this.getHotel = res.data.data
        let color = generateRandomColors(data.length)
        this.chart_2_5.setOption({
          //你的代码
          backgroundColor: "transparent",
          color: color,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
            },
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['30%', '60%'],
              center: ['50%', '55%'], // 修改为居中
              avoidLabelOverlap: true,
              label: {
                color: '#fff',
                alignTo: 'labelLine',
                formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                minMargin: 5,
                edgeDistance: 10,
                lineHeight: 15,
                rich: {
                  num: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  },
                  zb: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  }
                }
              },
              labelLine: {
                length: 15,
                length2: 40,
                maxSurfaceAngle: 80
              },
              data: data
            }
          ]
        })
      })
      //  应用时长频率
       appPerformanceGetAppUseFrequenceAndTime(this.form).then(res => {
        let data = res.data.data.appUseTime.map(item => ({
          value: item.count,
          name: item.app_use_time
        }))
        let color = ["#FF5733", "#3357FF",];
        let data1 = res.data.data.appUseFrequence.map(item => ({
          value: item.count,
          name: item.app_use_frequence
        }))
        let color1 = ["#FF5733", "#3357FF",];
        this.chart_2_6.setOption({
          //你的代码
          backgroundColor: "transparent",
          color: color,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
            },
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['20%', '40%'],
              center: ['50%', '55%'], // 修改为居中
              avoidLabelOverlap: true,
              label: {
                color: '#fff',
                alignTo: 'labelLine',
                formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                minMargin: 5,
                edgeDistance: 10,
                lineHeight: 15,
                rich: {
                  num: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  },
                  zb: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  }
                }
              },
              labelLine: {
                length: 15,
                length2: 40,
                maxSurfaceAngle: 80
              },
              data: data
            }
          ]
        })
        this.chart_2_7.setOption({
          //你的代码
          backgroundColor: "transparent",
          color: color1,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(13,5,30,.6)',
            borderWidth: 1,
            borderColor: '#32A1FF',
            padding: 5,
            textStyle: {
              color: '#fff'
            },
            confine: true,
            formatter(params) {
              if (params.name === '') {
                return '';
              }
              return `${params.name} : ${params.value}人 占比 : ${params.percent}%`;
            },
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['20%', '40%'],
              center: ['50%', '55%'], // 修改为居中
              avoidLabelOverlap: true,
              label: {
                color: '#fff',
                alignTo: 'labelLine',
                formatter: '{name|{b}}：{num|{c}}人 \n\n{zb|{d}}%',
                minMargin: 5,
                edgeDistance: 10,
                lineHeight: 15,
                rich: {
                  num: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  },
                  zb: {
                    fontSize: 14,
                    color: '#FFFFFF'
                  }
                }
              },
              labelLine: {
                length: 15,
                length2: 40,
                maxSurfaceAngle: 80
              },
              data: data1
            }
          ]
        })
      })
      //  app安装
       appPerformanceGetAppInstallTop(this.form).then(res => {
        let radarData = res.data.data.app_stats.map(item => ({
          name: item.app_name,
          value: item.user_count
        }))
        let valueList = radarData.map((it) => {
          return it.value;
        });
        let vlueMax = Math.max(...valueList);
        vlueMax = vlueMax + vlueMax * 0.2;
        let indicator = radarData.map((it) => {
          return {name: it.name, max: vlueMax};
        });
        let seriesData = [{value: valueList}];
        this.chart_2_8.setOption({
          backgroundColor: 'transparent',
          title: {
            text: "",
            x: "center",
            textStyle: {
              fontSize: 12
            }
          },
          grid: {
            top: '10%'
          },
          tooltip: {
            show: true,
            trigger: "item"
          },
          radar: {
            center: ["50%", "50%"],
            radius: "70%",
            shape: "circle",
            splitArea: {
              areaStyle: {
                color: ["transparent"]
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "rgba(34,50,129,1)"
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(34,50,129,1)"
              }
            },
            name: {
              textStyle: {
                color: 'white',
                fontSize: 14
              },
            },
            indicator: indicator
          },
          series: [{
            type: "radar",
            name: '月度风险指数',
            symbol: "circle",
            symbolSize: 4,
            itemStyle: {
              normal: {
                color: 'rgba(059, 114, 230,1)',
                borderColor: "rgba(059, 114, 230,0.5)",
                borderWidth: 6
              }
            },
            areaStyle: {
              normal: {
                color: "rgba(059, 114, 230,0.5)"
              }
            },
            lineStyle: {
              normal: {
                color: "rgba(059, 114, 230,1)",
                width: 2,
              }
            },
            label: {

              normal: {
                show: true,
                color: 'white',
                position: 'top'
              }
            },
            data: seriesData
          }]
        })
      })

      loading.close();
    },
    addressList(value) {
      this.valueCity = value
    },
    // 选择的类型
    TypeList(i) {
      if (this.currentAppType.includes(i)) {
        // 如果包含，则过滤掉该值（移除）
        this.currentAppType = this.currentAppType.filter(item => item !== i);
      } else {
        // 如果不包含，则添加该值
        this.currentAppType.push(i);
      }
    },
    // 确认类型
    async getAppListSumbit() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.form.appType = this.currentAppType.join(',')
      await appPerformanceGetAppList(this.form).then(res => {
        this.getAppList = res.data.data
        loading.close();
      })
    },
    handleResize() {
      this.Chart_1.resize()
      this.Chart_2.resize()
      this.chart_3.resize()
      this.chart_4.resize()
      this.chart_5.resize()
      this.chart_6.resize()
      this.chart_7.resize()
      this.chart_8.resize()
      this.chart_9.resize()
      this.chart_10.resize()
      this.chart_11.resize()
      this.chart_12.resize()
      this.chart_2_1.resize()
      this.chart_2_2.resize()
      this.chart_2_3.resize()
      this.chart_2_4.resize()
      this.chart_2_5.resize()
      this.chart_2_6.resize()
      this.chart_2_7.resize()
      this.chart_2_8.resize()
    }
  },
  mounted() {
    this.loading = this.$loading({
      lock: true,
      text: '加载中',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 1)'
    });
    this.$nextTick(async () => {
      await this.myChartFreeDom()  // 消费
      await this.myChartSex()  // 性别
      await this.myChartEdu()    // 文化
      await this.myChartCar()   // 车
      await this.myChartMarriage()  // 大学生婚姻
      await this.myChartPhone()  // 运营商 手机品牌
      window.addEventListener('resize', this.handleResize);
      this.loading.close()

    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
}


</script>


<style scoped lang="scss">
* {
  color: white;
  font-size: 14px;
}

.bg {
  width: 100%;
  height: 100vh;
  margin: 0 auto;
  padding: 16px 16px 0 16px;
  background-image: url("../../assets/pageBg.png");
  background-size: cover;
  background-position: center center;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.bg-item {
  width: 100%;
  height: 100%;
  background-color: rgba(15, 19, 37, 0.4);
}

.box-middle {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(3, 1fr); /* 2行等高 */
  width: 100%;
  gap: 10px;
  height: 90%;
}


.item-a {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}

.item-b {
  grid-row: 1 / 3;
  grid-column: 2 / 4;
  //text-align: center;
}

.left-box-text {
  background-color: rgba(19, 25, 47, 0.6);
  width: 30px;
  writing-mode: vertical-rl;
  line-height: 30px;
  text-align: center
}

.totalList {
  width: 80%;
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  //background-color: rgba(0, 0, 0, 0.3);
  border-radius: 4px;

  > div {
    display: flex;
    flex-wrap: nowrap;
    gap: 8px;
    justify-content: flex-end;
  }

  .el-button {
    margin: 0 !important;
    padding: 6px 12px;
    font-size: 12px;
    border-radius: 4px;
    transition: all 0.3s ease;
    border: 1px solid rgba(255, 255, 255, 0.2);
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff;

    &:hover {
      background-color: rgba(64, 158, 255, 0.7);
      transform: translateY(-2px);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    }

    &.is-active, &.active {
      background-color: #409EFF;
      color: #fff;
      font-weight: bold;
    }
  }
}

.progress-container {
  height: 12px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  overflow: hidden;
  margin-right: 10px;
  display: inline-block;
  width: 80%;
}

.progress-bar {
  height: 100%;
  transition: width 0.5s ease-in-out;
}

/* 修改表格背景色 */
:deep(.el-table) {
  background-color: transparent !important; /* 透明背景 */
  color: #fff; /* 文字颜色 */
}

/* 表头背景色 */
:deep(.el-table th) {
  background-color: rgba(0, 0, 0, 0.3) !important;
}

/* 表格行背景色 */
:deep(.el-table tr) {
  background-color: rgba(15, 19, 37, 0.4) !important;
}

/* 鼠标悬停行背景色 */
:deep(.el-table--enable-row-hover .el-table__body tr:hover > td) {
  background-color: rgba(64, 158, 255, 0.7) !important;
}

/* 单元格边框色 */
:deep(.el-table td, .el-table th) {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
}

/* 隐藏 el-table 的滚动条 */
:deep(.el-table__body-wrapper::-webkit-scrollbar) {
  display: none; /* Chrome/Safari */
}

:deep(.el-table__body-wrapper) {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
}

.getApp {

  display: grid;
  grid-template-columns: repeat(10, 1fr);

  .el-button {
    margin: 0 !important;
    padding: 6px 12px;
    font-size: 12px;
    border-radius: 4px;
    transition: all 0.3s ease;
    border: 1px solid rgba(255, 255, 255, 0.2);
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff;

    &:hover {
      background-color: rgba(64, 158, 255, 0.7);
      transform: translateY(-2px);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    }

    &.is-active, &.active {
      background-color: #409EFF;
      color: #fff;
      font-weight: bold;
    }
  }

}

.hide-scroll {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.hide-scroll::-webkit-scrollbar {
  display: none;
}

:deep(.el-progress__text) {
  display: none !important;
}

</style>
